module.exports = __webpack_public_path__ + "img/SBB Weihnachtszug.df8bc547.jpg";